import React from 'react';
import {HelpTip, Vertical, Horizontal, Heading, Button} from '@taopix/taopix-design-system';
import {t} from 'i18next';

type AssistantStepTipPropTypes = {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  anchorId?: string;
  nextFocusContainerId?: string; // The ID of a container element within which to focus after the tip is closed
  nextFocusElementId?: string; // The ID of an element on which to focus after the tip is closed
};

const AssistantStepTip = ({
  open,
  onClose,
  title,
  message,
  anchorId = 'assistant-sub-header',
  nextFocusContainerId,
  nextFocusElementId,
}: AssistantStepTipPropTypes) => {
  const handleClose = () => {
    if (nextFocusContainerId) {
      // Focus on the first focusable element within the container
      const container = document.getElementById(nextFocusContainerId);
      if (container) {
        const focusableElements = container.querySelectorAll<HTMLElement>(
          'button, input, select, textarea, a'
        );
        focusableElements[0]?.focus();
      }
    } else if (nextFocusElementId) {
      // Focus on the element with the given ID
      document.getElementById(nextFocusElementId)?.focus();
    }
    onClose();
  };

  return (
    <HelpTip
      open={open}
      anchorId={anchorId}
      anchorOrigin={{
        vertical: Vertical.Top,
        horizontal: Horizontal.Centre,
      }}
      transformOrigin={{
        vertical: Vertical.Top,
        horizontal: Horizontal.Centre,
      }}
      offset={{x: 0, y: 10}}
      className="flex-col items-center text-center p-lg w-[min(theme(width.bounds),300rem)]"
      repositionOnResize
      focusFirstElement
    >
      <Heading>{title}</Heading>
      <p dangerouslySetInnerHTML={{__html: message}}></p>
      <Button
        label={t('*:str_ButtonOK')}
        buttonStyle={'primary'}
        onClick={handleClose}
        className={'mt-lg'}
      />
    </HelpTip>
  );
};

export default AssistantStepTip;
